<template>
  <div
    class="associationConfigurationNewFile associationConfigurationNewFileClass"
  >
    <div class="dialog-title">
      修改密码
      <i class="close-dialog el-icon-close" @click="closeFun(false)"></i>
    </div>
    <div class="Content-box">
      <div class="search-biaozhu">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          label-width="124px"
          :rules="rules"
          ref="formInline"
        >
          <el-form-item label="用户账号：" prop="userName">
            <el-input
              disabled
              v-model="formInline.userName"
              placeholder=""
              show-word-limit
              class="input-right"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="旧密码："
            prop="password"
            style="padding-bottom: 10px"
          >
            <el-input
              type="password"
              v-model="formInline.password"
              placeholder=""
              show-word-limit
              class="input-right"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新密码："
            prop="newPassword"
            style="padding-bottom: 10px"
          >
            <el-input
              type="password"
              v-model="formInline.newPassword"
              placeholder="注:密码长度8到16位，至少包含大写字母、小写字母、数字(不能存在空格)"
              show-word-limit
              class="input-right"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认：" prop="confirmPassword">
            <el-input
              type="password"
              v-model="formInline.confirmPassword"
              placeholder="注:密码长度8到16位，至少包含大写字母、小写字母、数字(不能存在空格)"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btns">
        <el-button class="true" @click="submitForm()">确 定</el-button>
        <el-button
          class="false"
          style="margin-left: 20px"
          @click="closeFun(false)"
          >取 消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// 接口文件
import { logoutNew, editUserPassword } from '@/api';
export default {
  name: 'associationConfigurationNewFile',
  data() {
    var mima = (rule, value, callback) => {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]{8,16}$/;
      if (!re.test(value)) {
        callback(
          new Error(
            '格式错误->注:密码长度8到16位，至少包含大写字母、小写字母、数字(不能存在空格)',
          ),
        );
      } else {
        callback();
      }
    };
    var mimaTrue = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formInline.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
      // if (value != this.formInline.password) {
      //   callback(new Error('与之前输入的密码不一致，请重新输入'));
      // } else {
      //   callback();
      // }
    };
    return {
      formInline: {
        userName: '',
        password: '',
        confirmPassword: '',
        newPassword: '',
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入原始密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { required: true, validator: mima, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: mimaTrue, trigger: 'blur' },
        ],
      },
    };
  },
  components: {},
  created() {
    this.formInline.userName = localStorage.getItem('ms_username');
  },
  mounted() {},
  methods: {
    closeFun(type) {
      this.$emit('newDialogFun', type);
    },
    // 保存
    submitForm() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          editUserPassword(this.formInline).then((res) => {
            if (res.data.result) {
              this.$globalProcessing.reportErrors.success(res.data.msg);
              this.closeFun(true);
            } else {
              this.$globalProcessing.reportErrors.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped lang="less">
.associationConfigurationNewFileClass {
  .Content-box {
    margin-top: 36px;
    .tishi {
      color: #d45766;
      font-size: 14px;
      transform: translateY(-50%);
    }
  }
  .shebeileixing {
    /deep/.el-input {
      width: 165px !important;
    }
  }
  .ziyuanzu-btn {
    color: #56acff;
    background-color: #ffffff;
    border: 1px solid #56acff;
    padding: 9px 15px;
    font-size: 16px;
    border-radius: 3px;
    box-sizing: border-box;
    margin-right: 10px;
    cursor: pointer;
    line-height: 100%;
  }
  .input-right {
    /deep/input {
      padding-right: 74px;
    }
  }
  /deep/.search-biaozhu .el-input {
    width: 164px;
  }
  .search-biaozhu {
    border: 0;
  }
  .btns {
    margin-top: 0;
  }
  .search-biaozhu .el-input {
    width: 340px;
  }
  /deep/.search-biaozhu .el-input {
    width: 340px;
  }
  .search-biaozhu .el-textarea {
    width: 820px;
  }
}
</style>
